'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _components = require('components');

var _kunaUtils = require('../../utils/kunaUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import Clipboard from 'clipboard';

// const defaultDeleteText = 'Delete';

var Camera = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Camera, _Component);

  function Camera(props) {
    (0, _classCallCheck3.default)(this, Camera);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Camera.__proto__ || (0, _getPrototypeOf2.default)(Camera)).call(this, props));

    _this.showMore = function () {
      _this.setState(function (prevState) {
        return {
          showMore: !prevState.showMore
        };
      });
    };

    _this.state = {
      // showDeleteTooltip: false,
      // deleteTarget: null,
      // deleteTextToUser: defaultDeleteText,
      showMore: false
    };
    return _this;
  }

  (0, _createClass3.default)(Camera, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.onUpdate) {
        this.props.onUpdate();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          camera = _props.camera,
          rootCamera = _props.rootCamera,
          stats = _props.stats,
          onPlan = _props.onPlan,
          timezone = _props.timezone,
          shared = _props.shared,
          RMAUrl = _props.RMAUrl,
          returnUrl = _props.returnUrl,
          djangoUrl = _props.djangoUrl,
          logglyUrls = _props.logglyUrls,
          upToDateFW = _props.upToDateFW,
          isFwUpToDate = _props.isFwUpToDate,
          isBetaFW = _props.isBetaFW,
          onTrial = _props.onTrial,
          onUpdate = _props.onUpdate,
          trial = _props.trial,
          isNotificationOn = _props.isNotificationOn,
          isPIRSightCamera = _props.isPIRSightCamera,
          isSupportPermissionEnabled = _props.isSupportPermissionEnabled,
          isAdmin = _props.isAdmin;
      var showMore = this.state.showMore;


      var onlineButtonStyle = { color: camera.status === 1 ? 'green' : 'red' };
      var cameraContainerStyle = { marginLeft: '13px' };

      var sensitivityOverlay = 'This mirrors value seen by the user. Server value is: ' + camera.sensitivity;
      var userSensitivityValue = Math.round((255 - camera.sensitivity) * 100 / 255);

      var onSight = camera.sight_on;
      var customDetection = camera.sight_option === 1;

      var sightOverlay = 'This mirrors value seen by the user, lower is       less sensitive - range is -25 -> 25, default is 0.      Server value is:       ' + (rootCamera.sight.result && rootCamera.sight.result.sight_confidence) + ',       value on old apps is:       ' + (rootCamera.sight.result && 100 - rootCamera.sight.result.sight_confidence);

      var isDoorbell = (0, _kunaUtils.getModelFromSN)(camera.serial_number) === 'KUNA_V1';

      // const clipboardFunc = textToCopy => ref => {
      //   if (ref && Clipboard) {
      //     const clipboard = new Clipboard(ref, {text: () => textToCopy});
      //     clipboard.on('success', event => {
      //       this.setState({ deleteTextToUser: 'Request copied!'});
      //       setTimeout(() => this.setState({ deleteTextToUser: defaultDeleteText}), 4000);
      //       window.open(slackDeleteURI, '_self');
      //       event.clearSelection();
      //     });
      //   }
      // };

      var getLogglyButton = function getLogglyButton() {
        return _react2.default.createElement(
          _reactBootstrap.DropdownButton,
          {
            pullRight: true,
            bsSize: 'small',
            bsStyle: 'link',
            title: 'Loggly',
            id: 'Loggly'
          },
          logglyUrls.map(function (logglyEntry) {
            return _react2.default.createElement(
              _reactBootstrap.MenuItem,
              {
                target: '_blank',
                href: logglyEntry.url,
                key: logglyEntry.url
              },
              logglyEntry.name
            );
          })
        );
      };

      var getRecordingsButton = function getRecordingsButton() {
        var recordingsUrl = '/deviceDetailDashboard/' + camera.serial_number;
        if (onSight) {
          var sightImagesUrl = recordingsUrl + '?sightImages=true';
          return _react2.default.createElement(
            _reactBootstrap.DropdownButton,
            {
              bsStyle: 'danger',
              bsSize: 'xsmall',
              title: 'Recordings Data',
              id: 'bg-nested-dropdown'
            },
            _react2.default.createElement(
              _reactBootstrap.MenuItem,
              { eventKey: '1', target: '_blank', href: recordingsUrl },
              'Show Customer Recordings'
            ),
            _react2.default.createElement(
              _reactBootstrap.MenuItem,
              { eventKey: '2', target: '_blank', href: sightImagesUrl },
              'Show all sight images'
            )
          );
        }
        return _react2.default.createElement(
          _reactBootstrap.Button,
          {
            bsSize: 'xsmall',
            bsStyle: 'danger',
            type: 'button',
            target: '_blank',
            href: recordingsUrl
          },
          'Show Customer Recordings'
        );
      };

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'span',
            { style: onlineButtonStyle },
            '\u25CF '
          ),
          _react2.default.createElement(
            'strong',
            null,
            camera.serial_number,
            '   '
          ),
          isDoorbell && _react2.default.createElement(
            _reactBootstrap.Label,
            { bsStyle: 'primary' },
            'DB'
          ),
          camera.status !== 1 && !camera.down_at && _react2.default.createElement(
            _reactBootstrap.Label,
            { bsStyle: 'danger' },
            'Never online!'
          ),
          !isFwUpToDate && !isBetaFW && _react2.default.createElement(
            _reactBootstrap.Label,
            { bsStyle: 'primary' },
            'Old FW'
          ),
          !isFwUpToDate && isBetaFW && _react2.default.createElement(
            _reactBootstrap.Label,
            { bsStyle: 'success' },
            'Beta FW'
          ),
          onPlan && !camera.subscription && !onTrial && _react2.default.createElement(
            _reactBootstrap.Label,
            { bsStyle: 'danger' },
            'No Plan'
          ),
          shared && trial && onTrial && !camera.subscription && _react2.default.createElement(
            _reactBootstrap.Label,
            { bsStyle: 'danger' },
            'On Trial'
          ),
          shared && _react2.default.createElement(
            _reactBootstrap.Label,
            { bsStyle: 'warning' },
            'Shared'
          ),
          !isNotificationOn && _react2.default.createElement(
            _reactBootstrap.Label,
            { bsStyle: 'info' },
            'Notify off'
          ),
          onSight && _react2.default.createElement(
            _reactBootstrap.Label,
            { bsStyle: 'success' },
            'Sight'
          ),
          customDetection && !isPIRSightCamera && _react2.default.createElement(
            _reactBootstrap.Label,
            { bsStyle: 'warning' },
            'Custom Detection'
          ),
          customDetection && isPIRSightCamera && _react2.default.createElement(
            _reactBootstrap.Label,
            { bsStyle: 'danger' },
            'PIR based Sight!! (experiment)'
          ),
          isSupportPermissionEnabled && _react2.default.createElement(
            _reactBootstrap.Label,
            { bsStyle: 'primary' },
            'Support Permission'
          )
        ),
        _react2.default.createElement(
          'div',
          { style: cameraContainerStyle },
          _react2.default.createElement(
            'div',
            null,
            camera.name
          ),
          _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'a',
              { href: djangoUrl, target: '_blank', rel: 'noreferrer noopener' },
              'Django'
            ),
            ' | ',
            _react2.default.createElement(
              'a',
              { href: RMAUrl, target: '_blank', rel: 'noreferrer noopener' },
              'Replacement'
            ),
            ' | ',
            _react2.default.createElement(
              'a',
              { href: returnUrl, target: '_blank', rel: 'noreferrer noopener' },
              'Return'
            ),
            ' |',
            getLogglyButton()
          ),
          camera.status !== 1 && camera.down_at && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'strong',
              null,
              'Last time online'
            ),
            ' :',
            ' ',
            _react2.default.createElement(_components.DateText, { time: camera.down_at })
          ),
          !isFwUpToDate && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'strong',
              null,
              'Firmware'
            ),
            ' :',
            camera.build,
            ' instead of',
            upToDateFW
          ),
          shared && _react2.default.createElement(
            'div',
            { className: 'text-danger' },
            _react2.default.createElement(
              'strong',
              null,
              'Owner'
            ),
            ' :',
            camera.owner.email
          ),
          timezone !== camera.timezone && _react2.default.createElement(
            'div',
            { className: 'text-danger' },
            _react2.default.createElement(
              'strong',
              null,
              'Timezone'
            ),
            ' :',
            camera.timezone
          ),
          camera.created_at && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'strong',
              null,
              'Setup'
            ),
            ' :',
            _react2.default.createElement(_components.DateText, { time: camera.created_at })
          ),
          camera.support_permission_end && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'strong',
              null,
              'Support elevated permissions',
              isSupportPermissionEnabled ? ' ends' : ' ended'
            ),
            ' :',
            _react2.default.createElement(_components.DateText, { time: camera.support_permission_end })
          ),
          stats.map(function (singleStat) {
            return _react2.default.createElement(_components.WarningProperty, (0, _extends3.default)({
              showMore: showMore,
              onUpdate: onUpdate,
              key: singleStat.fieldName
            }, singleStat));
          }),
          shared && trial && !camera.subscription && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'strong',
              null,
              onTrial ? 'Trial until' : 'Trial ended'
            ),
            ' :',
            ' ',
            _react2.default.createElement(_components.DateText, { time: trial, fullDate: true })
          ),
          showMore && camera.sensitivity !== undefined && _react2.default.createElement(
            'div',
            { title: sensitivityOverlay },
            _react2.default.createElement(
              'strong',
              null,
              'Sensitivity'
            ),
            ' :',
            userSensitivityValue
          ),
          rootCamera && (onSight || isDoorbell) && showMore && rootCamera.sight.result !== undefined && _react2.default.createElement(
            'div',
            { title: sensitivityOverlay },
            _react2.default.createElement(
              'div',
              { title: sightOverlay },
              _react2.default.createElement(
                'strong',
                null,
                'Sight Sensitivity'
              ),
              ' :',
              ' ',
              60 - rootCamera.sight.result.sight_confidence
            ),
            _react2.default.createElement(_components.WarningProperty, {
              showMore: showMore,
              onUpdate: onUpdate,
              fieldName: 'Sight Mode',
              hoverText: 'What type of \'objects\' detected do we notify users on',
              value: (0, _kunaUtils.getSightMode)(rootCamera.sight.result.sight_notification),
              rawValue: 'ValidRawValue',
              formatting: function formatting(value) {
                return '' + value;
              },
              extendedInfo: _react2.default.createElement(_components.AreaOfInterest, {
                areaOfInterestData: rootCamera.sight.result
              })
            })
          ),
          _react2.default.createElement(
            'span',
            null,
            !showMore && _react2.default.createElement(
              _reactBootstrap.Button,
              { bsSize: 'xsmall', type: 'button', onClick: this.showMore },
              'Show More'
            ),
            '  ',
            (isSupportPermissionEnabled || isAdmin) && getRecordingsButton()
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_components.CameraDetail, this.props)
          )
        ),
        _react2.default.createElement('br', null)
      );
    }
  }]);
  return Camera;
}(_react.Component), _class.propTypes = {
  camera: _react.PropTypes.object,
  rootCamera: _react.PropTypes.object,
  stats: _react.PropTypes.array,
  email: _react.PropTypes.string,
  customerName: _react.PropTypes.string,
  zdTicketUrl: _react.PropTypes.string,
  onPlan: _react.PropTypes.bool,
  timezone: _react.PropTypes.string,
  shared: _react.PropTypes.bool,
  slackDeleteURI: _react.PropTypes.string,
  RMAUrl: _react.PropTypes.string,
  returnUrl: _react.PropTypes.string,
  djangoUrl: _react.PropTypes.string,
  logglyUrl: _react.PropTypes.string,
  logglyUrls: _react.PropTypes.array,
  deleteUrl: _react.PropTypes.string,
  deleteText: _react.PropTypes.string,
  firmwareModel: _react.PropTypes.string,
  upToDateFW: _react.PropTypes.number,
  isFwUpToDate: _react.PropTypes.bool,
  isBetaFW: _react.PropTypes.bool,
  firmware: _react.PropTypes.object,
  onUpdate: _react.PropTypes.func,
  onTrial: _react.PropTypes.bool,
  onCouponTrial: _react.PropTypes.bool,
  trial: _react.PropTypes.string,
  isNotificationOn: _react.PropTypes.bool,
  isPIRSightCamera: _react.PropTypes.bool,
  isSupportPermissionEnabled: _react.PropTypes.bool,
  isAdmin: _react.PropTypes.bool
}, _temp);
exports.default = Camera;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Camera/Camera.js
 ** module id = 1377
 ** module chunks = 0
 **/